import React, {useState} from "react";
import {Button, Dialog, DialogActions, DialogContent} from "@mui/material";
import {ClosableDialogTitle} from "@atttomyx/react-components";
import {forms, objects} from "@atttomyx/shared-utils";

const toData = (item) => {
    return objects.deepCopy(item);
};

const ItemDialog = (props) => {
    const { label, item, options, form: Form, onCancel, onOk } = props;
    const [ data, setData ] = useState(toData(item));

    return <Dialog
        open={true}
        aria-labelledby="item-dialog"
    >
        <ClosableDialogTitle onClose={onCancel}>
            {label}
        </ClosableDialogTitle>
        <DialogContent className="item-dialog">
            <Form
                options={options}
                data={data}
                onChange={setData}
            />
        </DialogContent>
        <DialogActions>
            <Button
                color="primary"
                disabled={!data.valid || !forms.differ(toData(item), data)}
                onClick={() => onOk(data)}
            >
                Ok
            </Button>
        </DialogActions>
    </Dialog>
}

export default ItemDialog;
